export default __webpack_public_path__ + "static/media/oops.e212f4b4.svg";